// List of legends for the map and in which organisms they appear
export const mapLegends = [
  { value: 'MDR', label: 'Multidrug resistant (MDR)' },
  { value: 'XDR', label: 'Extensively drug resistant (XDR)' },
  { value: 'ESBL_category', label: 'Ceftriaxone resistant' },
  { value: 'AzithR', label: 'Azithromycin resistant' },
  { value: 'CipNS', label: 'Ciprofloxacin non-susceptible (CipNS)' },
  { value: 'CipR', label: 'Ciprofloxacin resistant (CipR)' },
  // { value: 'Sensitive to all drugs', label: 'Sensitive to all drugs' },
  { value: 'Pansusceptible', label: 'Pansusceptible' },
  { value: 'Dominant Genotype', label: 'Dominant Genotype' },
  { value: 'Genotype prevalence', label: 'Genotype prevalence' },
  { value: 'H58 / Non-H58', label: 'H58 genotype' },
  { value: 'No. Samples', label: 'No. Samples' }
];
